import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import User from '@/models/User'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL

const AuthService = {
  state: {
    user: JSON.parse(localStorage.getItem('user')) || '',
    token: localStorage.getItem('token') || ''
  },
  mutations: {
    init_state (state, payload) {
      state.token = payload.token
      state.user = payload.user
    },
    empty_state (state) {
      state.token = ''
      state.user = ''
    }
  },
  actions: {
    login ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/login',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            const user = new User(resp.data.user)
            const token = resp.data.access_token
            localStorage.setItem('token', token)
            localStorage.setItem('user', JSON.stringify(user))
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            commit('api_success')
            commit('init_state', { token, user })
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/logout',
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            commit('empty_state')
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            delete axios.defaults.headers.common['Authorization']
            resolve()
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    getToken: state => state.token,
    user: state => state.user,
    hasMartinellisRole: state => state.user.role === 'martinellis',
    hasC1868Role: state => state.user.role === '1868'
  }
}

export default AuthService



// WEBPACK FOOTER //
// ./src/services/authService.js